import { TrackingDataListItem, TrackingV2Service } from '@api'
import { createEffect, createStore } from 'effector'

import { $creators } from '@/models/creators'
import { CreatorFeatures } from '@/modules/accounts/types'
import { isActiveCreator } from '@/modules/creators/utils'
import { handleError } from '@/utils/error'
import { dateToString } from '@/utils/helpers'

// Leaderboard Activity States (multiple creators)
export const fetchLeaderboardActivityStatesFx = createEffect({
  name: 'fetch chatter leaderboard activity states',
  handler: async ({
    from,
    to,
    creatorIds,
  }: {
    from: Date
    to: Date
    creatorIds: number[]
  }) => {
    if (creatorIds.length === 0) {
      return {
        dataList: [],
        revenues: {},
        total: [],
      }
    }

    return await TrackingV2Service.findLeaderboard({
      from: dateToString(from),
      to: dateToString(to),
      creatorIds,
    })
  },
})

fetchLeaderboardActivityStatesFx.failData.watch((error) => {
  handleError(error, 'Failed to fetch chatter leaderboard activity states')
})

export const $leaderboardActivityStates = createStore<
  TrackingDataListItem[] | null
>(null).on(
  fetchLeaderboardActivityStatesFx.doneData,
  (_, data) => data.dataList,
)

export const $isLeaderboardActivityLoading = createStore<boolean>(false)
  .on(fetchLeaderboardActivityStatesFx, () => true)
  .on(fetchLeaderboardActivityStatesFx.finally, () => false)

// Filtered creators for leaderboard
export const $filteredLeaderboardCreators = $creators.map((creators) =>
  creators.filter(
    (creator) =>
      creator.permissions.includes('SEE_CHATTER_TRACKING') &&
      creator.features.includes(CreatorFeatures.tracking) &&
      isActiveCreator(creator),
  ),
)
